import { AvailableServiceTimeSlots } from "../../data/entities/booking/AvailableServiceTimeSlots";
import { BookingModel } from "../../data/entities/booking/BookingModel";
import { BookingODataRepo, BookingRepo } from "../../data/repo";
import { BookingInvoice } from "../../models/booking/BookingInvoice";
import { BaseEntityService } from "../BaseEntityService"

export class BookingService extends BaseEntityService<BookingModel, BookingRepo, BookingODataRepo> {
  constructor(){
    super(new BookingRepo(), new BookingODataRepo());
  }

  async getAvailableServiceTimeSlots(locationId: number, providerId: number | null, serviceId: number, startDate: Date, endDate: Date): Promise<AvailableServiceTimeSlots[]> {
    const slots = await this.repo.getAvailableServiceTimeSlots(locationId, providerId, serviceId, startDate, endDate);
    return slots || [];
  }

  async getAvailableServiceDays(locationId: number, startDate: Date, endDate: Date, serviceProviderPairs: Record<number, number | null>): Promise<Date[]> {
    const availableDays = await this.repo.getAvailableServiceDays(locationId, startDate, endDate, serviceProviderPairs);
    return availableDays || [];
  }

  async initiateBooking(booking: BookingModel): Promise<BookingInvoice | null> {
    return await this.repo.initiateBooking(booking);
  }

  async markBookingAsCompletedAsync(bookingId: number): Promise<void | null> {
    return await this.repo.markBookingAsCompletedAsync(bookingId);
  }

  async getBookingWithInvoiceAsync(bookingId: number):Promise<BookingInvoice | null>{
    return await this.repo.getBookingWithInvoiceAsync(bookingId);
  }

  async discardDraftBookingAsync(bookingId: number, invoiceId: number): Promise<void | null>{
    return await this.repo.discardDraftBookingAsync(bookingId, invoiceId);
  }

  async getDraftStatus(bookingId: number): Promise<{ bookingId: number; status: string; invoiceId?: number; expiresAtUtc?: string } | null> {
    return await this.repo.getDraftStatus(bookingId);
  }

  async getCancelPreviewAsync(token: string): Promise<any> {
    return await this.repo.getCancelPreviewAsync(token);
  }

  async cancelByTokenAsync(token: string): Promise<void | null> {
    return await this.repo.cancelByTokenAsync(token);
  }
}
export default BookingService;
